import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import {
  AdsPrincipalListRBAC,
  UpsertTopUpAdsRBAC,
  AdsPrincipalDetailRBAC,
  AdsApprovalPageRBAC,
  AdsEfakturRBAC,
  AdsPph23RefundRBAC,
} from 'features/AdsManagement/rbac'

const AdsPrincipalList = lazy(() => import('../pages/AdsPrincipalList'))
const UpsertAds = lazy(() => import('../pages/UpsertTopUpAds'))
const AdsApproval = lazy(() => import('../pages/AdsApprovalPage'))
const AdsDetail = lazy(() => import('../pages/AdsPrincipalDetail'))
const AdsEfaktur = lazy(() => import('../pages/AdsEfaktur'))
const AdsPph23Refund = lazy(() => import('../pages/AdsPph23Refund'))

export const AdsPrincipalListRoute: RouterFeatureInterface<
  'adsPrincipalListRoute',
  '/dashboard/ads-management/ads-principal-list'
> = {
  name: 'adsPrincipalListRoute',
  Component: AdsPrincipalList,
  path: '/dashboard/ads-management/ads-principal-list',
  routeType: 'PRIVATE',
  rbacPageID: AdsPrincipalListRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const UpsertAdsRoute: RouterFeatureInterface<
  'upsertAdsRoute',
  '/dashboard/ads-management/upsert-ads'
> = {
  name: 'upsertAdsRoute',
  Component: UpsertAds,
  path: '/dashboard/ads-management/upsert-ads',
  routeType: 'PRIVATE',
  rbacPageID: UpsertTopUpAdsRBAC.pageID, // need to add rbac page id when it's available
  allowedRoles: [],
  isDashboard: true,
}

export const AdsApprovalRoute: RouterFeatureInterface<
  'adsApprovalRoute',
  '/dashboard/ads-management/ads-approval'
> = {
  name: 'adsApprovalRoute',
  Component: AdsApproval,
  path: '/dashboard/ads-management/ads-approval',
  routeType: 'PRIVATE',
  rbacPageID: AdsApprovalPageRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const AdsEfakturRoute: RouterFeatureInterface<
  'adsEfakturRoute',
  '/dashboard/ads-management/efaktur'
> = {
  name: 'adsEfakturRoute',
  Component: AdsEfaktur,
  path: '/dashboard/ads-management/efaktur',
  routeType: 'PRIVATE',
  rbacPageID: AdsEfakturRBAC.pageID, // stub — register when RBAC page is available
  allowedRoles: [],
  isDashboard: true,
}

export const AdsPph23RefundRoute: RouterFeatureInterface<
  'adsPph23RefundRoute',
  '/dashboard/ads-management/pph23-refund'
> = {
  name: 'adsPph23RefundRoute',
  Component: AdsPph23Refund,
  path: '/dashboard/ads-management/pph23-refund',
  routeType: 'PRIVATE',
  rbacPageID: AdsPph23RefundRBAC.pageID, // stub — register when RBAC page is available
  allowedRoles: [],
  isDashboard: true,
}

export const AdsPrincipalDetailRoute: RouterFeatureInterface<
  'adsPrincipalDetailRoute',
  '/dashboard/ads-management/detail/:id'
> = {
  name: 'adsPrincipalDetailRoute',
  Component: AdsDetail,
  path: '/dashboard/ads-management/detail/:id',
  routeType: 'PRIVATE',
  rbacPageID: AdsPrincipalDetailRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

const AdsManagementRouter = [
  AdsPrincipalListRoute,
  UpsertAdsRoute,
  AdsApprovalRoute,
  AdsEfakturRoute,
  AdsPph23RefundRoute,
  AdsPrincipalDetailRoute,
]

export const AdsManagementRouterDetail = generateRouterDetail(AdsManagementRouter)
export default AdsManagementRouter
